import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { EnterprisesService } from 'services/enterprises';
import { useEnterpriseId } from 'stores/user';
import { type GetEmployeesByEnterpriseParams } from 'types/enterprises';

export type EmployeeCountFilters = Pick<
  GetEmployeesByEnterpriseParams,
  'search' | 'hasUpcomingSession' | 'hasActiveRecord' | 'sessionStatus'
>;

export const useFetchEnterpriseEmployeesCount = (
  filters?: EmployeeCountFilters,
  enabled = true
): UseQueryResult<number, Error> => {
  const enterpriseId = useEnterpriseId();

  return useQuery({
    queryKey: filters
      ? [QUERY_KEYS.FETCH_INSURED_USERS_COUNT, enterpriseId, filters]
      : [QUERY_KEYS.FETCH_INSURED_USERS_COUNT, enterpriseId],
    queryFn: () => EnterprisesService.getCountEmployeesByEnterprise({ enterpriseId, ...filters }),
    select: response => response.data.count,
    enabled: Boolean(enterpriseId) && enabled,
  });
};
